import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, ButtonGroup } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import { findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

class LeadChangeStageForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      newStage: null,
      showAllStages: false,
    };
  }

  changeStage = newStageId => {
    this.props.onSubmitParent(newStageId);
  };

  render() {
    const { onSubmitParent, lead, appIntl } = this.props;

    const pipelineStages =
      lead.pipeline && lead.pipeline.stages ? lead.pipeline.stages : lead.getPipeline().getStages();
    const currentStage = lead.current_stage ? lead.current_stage : lead.getCurrentStage();

    const currentStageIndex = _findIndex(pipelineStages, ['id', currentStage]);
    const nextStage =
      pipelineStages[currentStageIndex + 1] !== undefined ? pipelineStages[currentStageIndex + 1] : null;

    return (
      <div>
        <div className="panel panel-transparent">
          <div>
            {nextStage ? (
              <div>
                <Button
                  block
                  bsSize="lg"
                  bsStyle="primary"
                  onClick={() => this.changeStage(nextStage.id ? nextStage.id : nextStage.getId())}
                >
                  {getNameInCurrentLanguage(nextStage.name ? nextStage.name : nextStage.getName(), appIntl)}
                </Button>
              </div>
            ) : null}

            <div className="m-t-20">
              <div className="text-center" style={{ display: this.state.showAllStages ? 'none' : 'block' }}>
                <Button className="btn-rounded" onClick={() => this.setState({ showAllStages: true })}>
                  <i className="fa fa-angle-down" />
                </Button>
              </div>

              <AnimateHeight duration={500} height={this.state.showAllStages ? 'auto' : 0}>
                <ButtonGroup vertical block>
                  {pipelineStages.map((stage, i) => {
                    return (
                      <Button
                        key={i}
                        bsSize="lg"
                        disabled={i === currentStageIndex}
                        onClick={() => this.changeStage(stage.id ? stage.id : stage.getId())}
                      >
                        {getNameInCurrentLanguage(stage.name ? stage.name : stage.getName(), appIntl)}
                      </Button>
                    );
                  })}
                </ButtonGroup>
              </AnimateHeight>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(connect(mapStateToProps)(LeadChangeStageForm));
